import fetchFactory from '../../../../../../utils/fetchFactory'

export const getJoursFeries = () => fetchFactory(`/api/ec_${process.env.REACT_APP_TARGET}/calendrier/getJoursFeries`)
